class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      evt => evt.code === 'Escape' && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach(closeButton =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach(section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );

      if (section.id === 'cart-icon-bubble') {
        const itemCount = document.getElementById(section.id).querySelector('span[aria-hidden="true"]').innerHTML;
        this.updateHeaderCartIcon(parseInt(itemCount, 10));
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  updateHeaderCartIcon(itemCount) {
    const updateCartText = (element) => {
      if (!element) return;
      
      const textElement = element.querySelector('.header-cart-summary-text span span[aria-hidden="true"]');
      const visuallyHidden = element.querySelector('.visually-hidden');
      
      this.updateTextElement(textElement, itemCount);
      this.updateVisuallyHidden(visuallyHidden, itemCount);
    };

    // Update all cart icons
    document.querySelectorAll('#cart-icon-bubble').forEach(updateCartText);
    
    // Update mobile cart icon
    const mobileCartIcon = document.querySelector('.header-mobile-cart-search-wrapper #cart-icon-bubble');
    updateCartText(mobileCartIcon);
  }

  updateTextElement(element, itemCount) {
    if (!element) return;
    
    if (itemCount === 0) {
      element.textContent = '';
      element.style.display = 'none';
    } else {
      element.textContent = `${itemCount} item(s)`;
      element.style.display = '';
    }
  }

  updateVisuallyHidden(element, itemCount) {
    if (!element) return;
    
    element.textContent = itemCount === 0 
      ? window.cartStrings?.empty || 'Cart'
      : `${itemCount} item(s)`;
  }
}

customElements.define('cart-notification', CartNotification);
